/**
 * @namespace geo.canvas
 */
module.exports = {
  canvasRenderer: require('./canvasRenderer'),
  heatmapFeature: require('./heatmapFeature'),
  isolineFeature: require('./isolineFeature'),
  lineFeature: require('./lineFeature'),
  pixelmapFeature: require('./pixelmapFeature'),
  quadFeature: require('./quadFeature'),
  textFeature: require('./textFeature'),
  tileLayer: require('./tileLayer'),
  trackFeature: require('./trackFeature')
};
